import { create } from 'zustand';

interface LayoutStore {
  dossierOpen: boolean;
  toggleDossier: () => void;
  setDossierOpen: (open: boolean) => void;
}

export const useLayoutStore = create<LayoutStore>((set) => ({
  dossierOpen: false,
  toggleDossier: () => set((state) => ({ dossierOpen: !state.dossierOpen })),
  setDossierOpen: (open) => set({ dossierOpen: open }),
}));
